<template>
  <div
    v-show="isShow"
    class="card shadow m-3 position-fixed right-0 top-0"
    style="z-index:1"
  >
    <div class="card-body d-flex align-items-center">
      <div
        :class="{ 'rotate': !complete }"
        class="mr-3 rounded-round d-flex align-items-center justify-content-center p-2 border-2 border-primary text-primary"
        style="width:50px; height:50px;"
      >
        <i class="fa-solid fa-hourglass-half fa-2x" />
      </div>
  
      <div>
        <div
          class="progress rounded-round mb-2"
          style="height:12px"
        >
          <div
            class="progress-bar bg-primary rounded-round"
            :style="`width:${progressBarWidth}%;`"
          >
            <!-- <span class="label-percent"></span> -->
          </div>
        </div>
        <div>
          <!-- กำลังสร้างหมายเลขแทรคกิ้ง 4 รายการจากทั้งหมด 50 รายการ --> 
          {{ $t('_Activities.Creating {countCreateActivity} activities from {totalActivity} total activities') | replaceText(countCreateActivity, totalActivity) }}
        </div>
  
        <div v-if="showLogError">
          <a
            href="#collapse-icon"
            class="collapsed font-size-sm text-default"
            data-toggle="collapse"
          >
            <span class="text-muted">{{ $t('Activity Logs') }}</span> <i
              class="fa-regular fa-triangle-exclamation text-danger"
            />
          </a>
        </div>
      </div>
      <button
        :class="{ 'text-muted': !closeModal }"
        @click="closeModalProgressActivity()"
        type="button"
        class="close align-self-start ml-2 mr-n1 mt-n2"
      >
        <span>×</span>
      </button>
    </div>
  
    <div
      v-if="showLogError"
      style="max-width: 320px;"
    >
      <div
        class="collapse"
        id="collapse-icon"
      >
        <div
          v-if="completeList"
          class="card-body border-left-warning border-left-2 pl-0 pt-0"
          style="max-height: 600px; overflow-x: hidden; overflow-y: auto;"
        >
          <ul class="list mb-0">
            <li
              v-for="(list, i) in completeList"
              :key="'list' + i"
              class="font-size-sm mb-2"
              :class="{ 'text-danger': !list.status }"
            >
              <span v-if="list.status">({{ list.customerId }}) {{ list.message }}</span>
              <span v-else>({{ list.customerId }}) {{ list.message }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  import Api from '@/services/endpoint/tenant.service'
  import WebSocket from "isomorphic-ws";
  import Echo from "laravel-echo";
  import Cookies from "js-cookie";

  export default {
  data() {
    const vm = this;
    return {
      closeModal: false,
      completeList: [],
      totalActivity: 0,
      countCreateActivity: 0,
      showLogError: false,
      websocket: null,
      isShow:false,
    }
  },
  computed: {
    progressBarWidth() {
      return this.countCreateActivity * 100 / this.totalActivity;
    },
    checkListReady() {
      return this.$store.state.shipment.checkListReady;
    },
    complete() {
      return this.completeList.length == this.totalActivity;
    }
  },
  methods: {
    closeModalProgressActivity() {
      // if (!this.closeModal) return;
      let vm =this;
      vm.$store.dispatch("customer/updateCustomerDataTablePregressBar", true);
      vm.$store.dispatch("customer/isProgressBarActivity", false)
    },
  
    async AddActivityFromBulkAction(){
      let self = this;
      this.disabledSubmit = true;
      try{
        let dataForm  = {}; 
        dataForm = this.$store.state.customer.activityDataPregressBar
        this.totalActivity = dataForm.customer_ids.length
        this.openWebsocket();

        let response = await Api.ActivitiesV2.postActivitiesCreateBatch(dataForm);
        if(response.status != 200){
          throw response;
        } 
        this.isShow = true;
        
      } catch(error) {
        console.log('error = ',error); 
        if(error.status == 403){
          if(error.status == 403 && (error.hasOwnProperty('data')&&(error.data.code == "ERROR_FEATURE_NOT_ALLOWED"))){
            this.switchAlert();
            setTimeout(() => {
              self.$store.dispatch("customer/updateCustomerDataTablePregressBar", '')
            }, 1000);
            return;
          }
          this.switchAlertAccessDenied();
          setTimeout(() => {
            self.$store.dispatch("customer/updateCustomerDataTablePregressBar", '')
          }, 1000);
          return;
        } 
        self.$toastr.Add({
            type: "error",
            title: "<span class='fa-regular fa-ban'></span>" + self.$t('Failed'),
            msg: self.$t('_Activities.Create Activity Failed'),
            clickClose: true,
            timeout: 5000,
            position: "toast-top-right"
          }); 
        setTimeout(() => {
          self.$store.dispatch("customer/updateCustomerDataTablePregressBar", '')
        }, 1000);
      }
      this.disabledSubmit = false;
    },
    openWebsocket() {
      let vm = this;
      if (localStorage.getItem('isCypress')) {
        let dataWebsocket = JSON.parse(localStorage.getItem('cypressDataWebsocket'));  
        if (dataWebsocket) {
          dataWebsocket.forEach(data => {
            let activityOnmessage = JSON.parse(JSON.stringify(data)) 
            if (activityOnmessage.data.clientUid == `create.activity.1.75` && activityOnmessage.event == `create.activity`) {
              vm.activityOnmessage(activityOnmessage);
            }
          }); 
        }
      } else {
        let ws = this.websocket = new WebSocket(process.env.WEBSOCKETS_GOQUEUE_URL);
        // Open websocket
        let userId = JSON.parse(Cookies.get('user')).id;
        const tenantId = JSON.parse(Cookies.get('tenant')).id; 
        ws.onopen = function open() {
            console.log('onopen')
            ws.send(JSON.stringify({
            "data": {
                "clientUid": `create.activity.${userId}.${tenantId}`
            },
            "event": "subscribe"
            }));
        };
      // Action websocket
        ws.onmessage = async function incoming(message) {
          let data = JSON.parse(message.data)

          if (data.data.clientUid == `create.activity.${userId}.${tenantId}` && data.event == `create.activity`) {
            vm.activityOnmessage(data);
          }
        }
      }
    
    },
    activityOnmessage(data){
      let vm = this;
      let paylaod = data.data;
      if (paylaod.status) {
          vm.countCreateActivity += 1;
          
      } else {
          if (!vm.showLogError) {
            vm.showLogError = true;
          }
          vm.countCreateActivity += 1;
          vm.completeList.unshift({
            'status': paylaod.status,
            'customerId': paylaod.customerId,
            'message': vm.$t(paylaod.message.split('"').join(''))
          });
      }
      vm.$store.dispatch("customer/setInProgressBarCustomer", {
        CustomerIds: [paylaod.customerId],
        status: paylaod.status ? "checkmark" : "cross",
      });

      if(vm.countCreateActivity >= vm.totalActivity){
        if (!vm.showLogError) {
          let timeout = 1000
          if (localStorage.getItem('isCypress')) {
            timeout = 10000
          }  

          setTimeout(() => {
            vm.$store.dispatch("customer/updateCustomerDataTablePregressBar", true); 
          }, 1000);

          setTimeout(() => {
            vm.$store.dispatch("customer/isProgressBarActivity", false)
          }, timeout);

          setTimeout(() => {
            if (!vm.showLogError) {
              vm.$toastr.s(vm.$t("_Activities.Create Activity Success"), "<i class='fa-solid fa-circle-check mr-2'></i>" + vm.$t('Success'));
            }
          }, 1000);
        }

        if (vm.countCreateActivity == vm.totalActivity) {
          vm.closeModal = true;
          if (vm.showLogError) {
            setTimeout(() => {
              vm.$toastr.e(vm.$t("_Activities.Create Activity Failed"), "<span class='fa-solid fa-ban mr-2'></span>" + vm.$t('Failed'));
            }, 1000);
          }
        }
      }
    },
    switchAlert(){
      const Swal = this.$swal;
      const self = this;
      Swal({
        imageUrl: require('@/assets/global_assets/images/access_not_available.png'),
        title: self.$t("Access Not Available") + "!",
        html: self.$t("Current plan is not support this feature.")+"<br/>"+self.$t("Please subscribe upper plan to access the feature."),
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: '<i class="fa-solid fa-envelope-open-dollar mr-2"></i>' + self.$t("Upgrade Now") + '!',
        buttonsStyling: false,
        cancelButtonText: '<i class="fa-solid fa-circle-check mr-2"></i>' + self.$t("Got It") + '!',
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary",
        },
        loaderHtml: '<div class="spinner-border text-primary"></div>',
        showLoaderOnConfirm: true,
        preConfirm: async function () {
          self.$router.push({ path: '/app/premium-subscriptions'});
        },
      });
    },
    switchAlertAccessDenied(){
      const Swal = this.$swal;
      const self = this;
      Swal({
        imageUrl: require('@/assets/images/activities/icon-access-denied.png'),
        title: self.$t('Access Denied')+' !',
        html: self.$t('You do not have permission to access this page.')+'<br/>'+self.$t('If you feel this is a mistake, contact your admin.'),
        confirmButtonText: '<i class="fa-solid fa-thumbs-up mr-1"></i>' + self.$t('OK'),
        customClass: {
            confirmButton: 'btn btn-primary',
        },
        focusConfirm: false
      });
    },
  },
  mounted() {
      this.AddActivityFromBulkAction();
  },
  beforeDestroy() {
    if (!localStorage.getItem('isCypress')) {
      let ws = this.websocket;
      ws.close();
    }
  },
  filters: {
    replaceText: function (text, countCreateActivity, totalActivity) {
      text = text.replace('{totalActivity}', totalActivity);
      text = text.replace('{countCreateActivity}', countCreateActivity);
      return text;
    }
  },
  }
  </script>
  
  <style scoped></style>
  


// WEBPACK FOOTER //
// src/components/tenancy/admin/crm/activities/ProgressBarActivity.vue